const WebFont = require( 'webfontloader' );

WebFont.load({
    google: {
        families: [ 'Lexend:300,400,600' ]
    }
});



// WEBPACK FOOTER //
// ./assets/scripts/fonts.js